module.exports = __webpack_public_path__ + "static/media/jackkid.c62bf26f.jpg";